export function sanitisePassword(password: string): string {
  // Remove whitespace
  const trimmed = password.trim();

  // Replace any non-standard unicode hyphens with the ascii one
  const safeHyphens = trimmed.replace(/[᠆‐‑‒–—―⸺⸻﹘﹣－]+/g, '-');

  // Remove any other non-ascii characters (we may want to change this one day!)
  // eslint-disable-next-line no-control-regex
  const totesAsciiSafe = safeHyphens.replace(/[^\x00-\x7F]/g, '');

  return totesAsciiSafe;
}

const MAX_CODE_LENGTH = 7;

export const formatCodeValue = (_value: string, isDelete: boolean) => {
  const value = _value.toUpperCase();
  const numDashes = value.match(/-/g)?.length ?? 0;
  if (
    !isDelete &&
    value &&
    value.length < MAX_CODE_LENGTH &&
    (value.length - numDashes) % 3 === 0
  ) {
    // Insert dash after every 3 characters, up to a max of MAX_CODE_LENGTH
    return `${value}-`;
  }

  // If deleting, we want to keep the dash at the end
  if (value.endsWith('-')) {
    return value;
  }

  // But if we're deleting the dash, we also want to remove the character before it
  if (isDelete && (value.length - numDashes) % 3 === 0) {
    return value.slice(0, -1);
  }

  return value;
};
